// extracted by mini-css-extract-plugin
export default {"container":"alertSummary_container__RRe1q","innerCard":"alertSummary_innerCard__1PxF4","table":"alertSummary_table__N8D6U"};